import Vue from 'vue';
import Vuex, { ModuleTree, Store } from 'vuex';
import { DefineMutations, Dispatcher } from 'vuex-type-helper';
import discounts, { ModuleActions as DiscountsActions } from './modules/discounts';
import newsletter from './modules/newsletter';
import officeSchedule from './modules/officeSchedule';
import orm from './modules/orm';
import trustpilot from './modules/trustpilot';
import ui from './modules/ui';
import youTube from './modules/youTube';

export interface Gender {
    value: number;

    display: string;
}

export interface RootState {
    debug: boolean;
}

export interface RootActions {
    loadState;
}

declare const process: {
    env: {
        NODE_ENV: string,
    },
};

Vue.use(Vuex);

const modules: ModuleTree<RootState> = {
    discounts,
    newsletter,
    officeSchedule,
    orm,
    trustpilot,
    ui,
    youTube,
};

const debug: boolean = process.env.NODE_ENV !== 'production';

const mutations: DefineMutations<{}, RootState> = {};

const state: RootState = {
    debug,
};

const store: Store<RootState> = new Vuex.Store({
    state,
    mutations,
    modules,
    strict: debug,
});

store.dispatch<Dispatcher<DiscountsActions>>({
    type: 'discounts/fetchDiscounts',
});

export default store;
